import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconCrossBold = props => (
  <SvgIcon {...props} viewBox="0 0 15.4142 15.4142">
    <path d="m13.307 0 2.1071 2.1071-5.6 5.6 5.6 5.6-2.1071 2.1071-5.6-5.6-5.6 5.6l-2.107-2.107 5.6-5.5999-5.6-5.6 2.1071-2.1071 5.6 5.6 5.5999-5.6z" />
  </SvgIcon>
);

export default IconCrossBold;



// WEBPACK FOOTER //
// ./src/components/icons/IconCrossBold.js